import { render, staticRenderFns } from "./recipesPdfNew.vue?vue&type=template&id=6f6abd3e&scoped=true&"
import script from "./recipesPdfNew.vue?vue&type=script&lang=js&"
export * from "./recipesPdfNew.vue?vue&type=script&lang=js&"
import style0 from "./recipesPdfNew.vue?vue&type=style&index=0&id=6f6abd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6abd3e",
  null
  
)

export default component.exports